import { graphql, useStaticQuery } from "gatsby";
import { SmsDownloadLinkModuleQuery } from "../../../graphql-types";
import { SMSDownloadLinkModuleProps } from "../SMSDownloadLinkModule";
import getFluidImageOrThrow from "../../shared/utilities/getFluidImageOrThrow";

function useSMSDownloadLinkModuleQuery() {
  const data = useStaticQuery(graphql`
    query SMSDownloadLinkModule {
      staticImagesJson {
        images {
          shortHairWomanWorkingOnPhone {
            fluid {
              ...CloudinaryAssetFluid_noBase64
            }
          }
          womanWorkingOnPhone {
            fluid {
              ...CloudinaryAssetFluid_noBase64
            }
          }
        }
      }
    }
  `) as SmsDownloadLinkModuleQuery;

  return data;
}

export function useSMSDownloadLinkModuleProps() {
  const data = useSMSDownloadLinkModuleQuery();

  const shortHairWomanWorkingOnPhoneFluid = getFluidImageOrThrow(
    "shortHairWomanWorkingOnPhone",
    data
  );

  const womanWorkingOnPhoneFluid = getFluidImageOrThrow(
    "womanWorkingOnPhone",
    data
  );

  const smsDownloadLinkModuleProps: SMSDownloadLinkModuleProps = {
    shortHairWomanWorkingOnPhoneFluid,
    womanWorkingOnPhoneFluid,
  };

  return smsDownloadLinkModuleProps;
}
